import { useStore } from "@/store";

import type { Folder } from "@/api";
import type { DocumentModel } from "@/models/DocumentModel";

function isDocumentInFolder(folder: Folder | undefined, docUid: string): boolean {
  if (!folder?.files) {
    return false;
  }
  for (const item of folder.files) {
    if (item.uid === docUid && item.typename === "DocumentShort") {
      return true;
    }
    if (item.typename === "Folder" && item.files) {
      if (isDocumentInFolder(item, docUid)) {
        return true;
      }
    }
  }
  return false;
}

/**
 * Returns true if the document is in the "published" folder of its team.
 * Uses documentTree when doc's team is current team, or publicProfile.published when viewing that team's profile.
 */
export function useIsPublicProfileDoc(doc?: DocumentModel): boolean {
  const { documentTree, publicProfile } = useStore();
  const docUid = doc?.id;
  const docTeamUid = doc?.api.team?.uid;

  if (!docUid || !docTeamUid) {
    return false;
  }

  // Current team's document tree: check parent folder
  if (documentTree.team?.uid === docTeamUid) {
    const { folder } = documentTree.getParentFolder(docUid);
    return folder?.uid === documentTree.published?.uid;
  }

  // Public profile view: check if doc is in published folder tree
  if (publicProfile.team?.uid === docTeamUid && publicProfile.published) {
    return isDocumentInFolder(publicProfile.published, docUid);
  }

  return false;
}
